import { render, staticRenderFns } from "./GuestItems.vue?vue&type=template&id=6be45920"
import script from "./GuestItems.vue?vue&type=script&lang=js"
export * from "./GuestItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports